module.exports = __webpack_public_path__ + "static/media/ruchinarain_th4bw.e77fc2f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ruchinarain_th4bw.png
// module id = 423
// module chunks = 0